import { jsx as r, jsxs as c } from "@emotion/react/jsx-runtime";
import { useTheme as u, ClassNames as k } from "@emotion/react";
import { HEX_COLORS as y, whiteColorObject as S } from "@partoohub/branding";
import { toast as s, ToastContainer as T, Slide as I } from "react-toastify";
import { styles as O, ContentTitleContainer as w, ContentBodyContainer as j, CloseButtonWrapper as A, StyledIconButton as B } from "./Snackbar.styled.js";
import { Icon as l } from "../Icon/index.js";
import { Stack as m } from "../Stack/index.js";
import { Text as L } from "../Text/index.js";
import { FontAwesomeIconsPartooUsed as n, IconPrefix as d } from "../../types/components/icon.js";
const N = 6e3, p = {
  warning: n.faCircleExclamation,
  success: n.faCircleCheck,
  danger: n.faCircleXmark,
  progress: n.faArrowsRotate
}, _ = ({
  closeToast: t
}) => /* @__PURE__ */ r(A, { type: "button", onClick: t, children: /* @__PURE__ */ r(B, { dataTrackId: "snackbar-close-toast", "aria-label": "Close toast", icon: [n.faClose], size: "xsmall", appearance: "contained", variant: "secondary" }) }), v = ({
  variant: t
}) => {
  const o = u();
  return t === "progress" ? /* @__PURE__ */ r(m, { alignItems: "center", justifyContent: "center", style: {
    backgroundColor: o.colors.primary.initial,
    height: "24px",
    width: "24px",
    borderRadius: "50px"
  }, children: /* @__PURE__ */ r(l, { icon: [p[t], d.SOLID], iconSize: "12px", color: S.initial, className: "fa-spin" }) }) : /* @__PURE__ */ r(m, { alignItems: "center", justifyContent: "center", style: {
    backgroundColor: "transparent",
    height: "24px",
    width: "24px",
    borderRadius: "50px"
  }, children: /* @__PURE__ */ r(l, { icon: [p[t], d.SOLID], iconSize: "18px", color: o.colors[t].background }) });
}, i = ({
  variant: t,
  children: o,
  title: e
}) => /* @__PURE__ */ c("div", { className: "Toastify__toast-body", children: [
  /* @__PURE__ */ c(w, { children: [
    /* @__PURE__ */ r(v, { variant: t }),
    /* @__PURE__ */ r(L, { variant: "heading6", as: "span", color: y.blackberry, children: e })
  ] }),
  /* @__PURE__ */ r(j, { children: o })
] }), W = {
  error: (t, o, e) => s.error(/* @__PURE__ */ r(i, { variant: "danger", title: o, children: t }), e),
  warning: (t, o, e) => s.warning(/* @__PURE__ */ r(i, { variant: "warning", title: o, children: t }), e),
  success: (t, o, e) => s.success(/* @__PURE__ */ r(i, { variant: "success", title: o, children: t }), e),
  loading: (t, o, e) => s.info(/* @__PURE__ */ r(i, { variant: "progress", title: o, children: t }), e),
  dismiss: (t, o) => o ? s.dismiss({
    id: t,
    containerId: o
  }) : s.dismiss(t),
  update: (t, o, e, a) => e ? s.update(t, {
    ...a,
    toastId: t,
    containerId: e,
    render: () => o
  }) : s.update(t, {
    ...a,
    render: () => o
  })
}, Y = ({
  dataTrackId: t,
  newestOnTop: o,
  limit: e,
  containerId: a,
  position: C = "bottom-left",
  hideProgressBar: f = !0,
  stacked: g = !0,
  autoClose: h = N
}) => {
  const x = u();
  return /* @__PURE__ */ r(k, { children: ({
    css: b
  }) => /* @__PURE__ */ r(T, { "data-track": t, containerId: a, closeButton: /* @__PURE__ */ r(_, {}), toastClassName: b(O.toast(x)), hideProgressBar: f, autoClose: h, icon: !1, newestOnTop: o, limit: e, position: C, closeOnClick: !0, stacked: g, transition: I }) });
};
export {
  i as ContentToast,
  Y as Snackbar,
  W as toast
};
